exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-circle-counter>div[data-v-01a61901]{margin-right:auto;margin-left:auto}.box-circle-counter p[data-v-01a61901]{text-align:center;font-weight:600}", ""]);

// exports
